<template>
    <router-link :to="{ name: 'detailNews', params: { uid: item.uid }}" class="important_card"  :style='{ backgroundImage: `url("${image}")` }'>
        <div class="news_body">

            <h2 class="mb-5" v-if="index < 1">{{ item.title }}</h2>
            <h4 v-else>{{ item.title }}</h4>
            <div v-if="item.author_name" class="author mt-2 item_opc">{{$t('author')}} {{item.author_name}}</div>
            <div class="date mt-2 item_opc">{{date}}</div>
            <button
                v-show="index < 1"
                class="mt-6 vs-component vs-button vs-button-primary vs-button-border">
                {{$t('more')}}
            </button>


        </div>
    </router-link>
</template>

<script>
export default {
    props: {
        item: Object,
        index: Number
    },
    computed: {
        image() {
            // Проверяем есть ли изображение и если есть то возвращаем ключ с ссылкой на изображение
            if(this.item.front_image)
                return this.item.front_image.path
        },
        date() {
            // Выводим дату в нужном формате
            return this.$moment(this.item.pub_date).format('LL')
        }
    }
}
</script>

<style lang="scss" scoped>
.important_card{
    display: block;
    background-color: #ffffff;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    overflow: hidden;
    border-radius: 5px;
    position: relative;
    color: #ffffff;
    transition: -webkit-transform .2s;
    transition: transform .2s;
    transition: transform .2s,-webkit-transform .2s;
    &:hover{
        transform: translateY(-4px);
        box-shadow: 0 3px 10px 0 #ccc;
        transition: all .2s;
    }
    .news_body{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding-bottom: 15px;
        padding-right: 15px;
        padding-left: 15px;
        padding-top: 200px;
        z-index: 10;
        background: -moz-linear-gradient(top,  rgba(0,0,0,0) 0%, rgba(0,0,0,0.65) 60%, rgba(0,0,0,0.75) 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top,  rgba(0,0,0,0) 0%,rgba(0,0,0,0.65) 60%,rgba(0,0,0,0.75) 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom,  rgba(0,0,0,0) 0%,rgba(0,0,0,0.65) 60%,rgba(0,0,0,0.75) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#a6000000',GradientType=0 ); /* IE6-9 */
        .item_opc{
            opacity: 0.8;
        }
        h2,
        h4{
            color: #ffffff;
        }
    }
}
@media only screen and (max-width: 900px) {
    .important_card{
        min-height: 150px;
        .author{
            font-size: 13px;
        }
        .date{
            font-size: 13px;
        }
        h2{
            font-size: 18.48px;
            margin-bottom: 0px!important;
        }
    }
}
</style>
